import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Listable, { VIEW_TYPES } from "../../components/Listable";
import Loader from "../../components/Loader";
import i18n from "../../lib/i18n";
import Product from "../../models/Product";

import "./style.scss";

export default function ProductsList() {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  useEffect(() => {
    setIsLoading(true);
    Product.getProductsList().then(result => {
      setProducts(result);
      setIsLoading(false);
    }).catch(err => {
      setErrorMessage(err);
    });
  }, [setProducts]);

  if (errorMessage) {
    return <div className="centered h-100pc">No products for you today. Server gave up. :(</div>;
  }

  if (isLoading) {
    return (
      <div className="centered h-100pc">
        <Loader />
      </div>
    );
  }

  return (
    <div className="ProductsList page-clamp">
      <Listable title={i18n("products.title")}
        defaultViewType={VIEW_TYPES.GRID}
        views={{
          [VIEW_TYPES.GRID]: data => (
            <Link to={`/product/${data.id}`} className="link-clean flex-column">
              <img className="w-360px mobile-w-100pc" src={data.images.medium} alt="Product thumbnail"></img>
              <div className="flex-column p-md">
                <h3>{data.name}</h3>
              </div>
            </Link>
          ),
          [VIEW_TYPES.LIST]: data => (
            <Link to={`/product/${data.id}`} className="link-clean">
              <div className="flex-row">
                <img className="h-64px" src={data.images.small} alt="Product thumbnail"></img>
                <div className="flex-column flex-justify-center p-md">
                  <h3>{data.name}</h3>
                </div>
              </div>
            </Link>
          )
        }}
        listItems={products}
      ></Listable>
    </div>
  )
}